export function scaledLogoUri(
  uri: string,
  maxWidth: number,
  maxHeight: number,
): string {
  return `${uri}?maxWidth=${maxWidth}&maxHeight=${maxHeight}`;
}
